import React from "react";
import {useHistory} from "react-router";
import {Box} from "@unibuddy/patron";

import SignupForm from "ubcommunity-shared/src/Auth/Signup/SignupStep1";
import {PageTitles} from "ubcommunity-shared/src/constants";
import {usePageTitle} from "ubcommunity-shared/src/Hooks/usePageTitle";

import {BackButton} from "../../Layout/BackButton/BackButton";

export default function SignupStep1() {
    usePageTitle(PageTitles.SIGNUP_STEP_1);
    const history = useHistory();

    return (
        <>
            <Box minW="100%" paddingY="xxsmall" flexShrink={0}>
                <BackButton to="" onClick={() => history.goBack()} />
            </Box>
            <SignupForm />
        </>
    );
}
